"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxGridAreaContainer'
};
var useStyles = (0, _styles.makeStyles)({
  root: {
    width: '100%'
  },
  gridAreaName: function gridAreaName(_ref) {
    var renderToGridArea = _ref.renderToGridArea;
    return {
      gridArea: renderToGridArea
    };
  }
}, themeSettings);

var GridAreaContainer = /*#__PURE__*/_react.default.forwardRef(function GridAreaContainer(_ref2, ref) {
  var children = _ref2.children,
      pClasses = _ref2.classes,
      className = _ref2.className,
      renderToGridArea = _ref2.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["children", "classes", "className", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses,
    renderToGridArea: renderToGridArea
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref,
    className: (0, _clsx.default)(classes.gridAreaName, classes.root, className)
  }, rest), children);
});

process.env.NODE_ENV !== "production" ? GridAreaContainer.propTypes = {
  renderToGridArea: _propTypes.default.string.isRequired
} : void 0;

var _default = (0, _withThemeProps.default)(themeSettings)(GridAreaContainer);

exports.default = _default;